// import styles
import { Skeleton } from '@mui/material';
import { StyledControlledReadOnlyTextField } from './ControlledReadOnlyField.styles';

// import types
import { SettlementFormValues } from 'components/roster-portal/home/end-of-employment-settlements/components/EndOfEmploymentSettlementsForm.types';

export const ControlledReadOnlyField = ({
  control,
  name,
  label,
  shouldShow,
  isLoading
}: {
  control: any;
  name: keyof SettlementFormValues;
  label: string;
  shouldShow?: boolean;
  isLoading?: boolean;
}) => {
  if (shouldShow === false) return null;
  if (isLoading) return <Skeleton width="100%" height="40px" />;

  return (
    <StyledControlledReadOnlyTextField
      control={control}
      name={name}
      label={label}
      slotProps={{
        input: {
          readOnly: true
        }
      }}
    />
  );
};
